import * as contentful from 'contentful'

export const client = contentful.createClient({
    space: "fclf5233ao5l",
    accessToken: "gWCAeJGvCgN9Xk8j8f-xKGUaCms5fFC02rOUQmdwE6Y"
})